<script lang="ts">
  interface Props {
    course: CourseType
    course_progress: CourseProgressType
    onloadsubstep: (step: number) => void
  }

  let { course, course_progress, onloadsubstep }: Props = $props()

  let step = course.steps[course_progress.step - 1]
</script>

<div class="w-full">
  <div class="text-white text-sm">
    {step.title}
  </div>
  <nav aria-label="Progress" class="z-40 relative">
    <ol class="flex items-center mt-2">
      {#each step.substeps as substep, step_count}
        <li
          class="relative {step_count < step.substeps.length - 1
            ? 'pr-8 sm:pr-20'
            : ''}"
        >
          {#if step_count + 1 < course_progress.substep}
            <!-- Completed Step -->
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div
                class="h-0.5 w-full bg-white"
                style="height: 0.125rem;"
              ></div>
            </div>
            <button
              onclick={() => onloadsubstep(step_count + 1)}
              class="relative flex h-8 w-8 items-center justify-center rounded-full text-white bg-green-400 hover:bg-green-600"
            >
              {step_count + 1}
              <span class="sr-only">Step {step_count + 1}</span>
            </button>
          {:else if step_count + 1 == course_progress.substep}
            <!-- Current Step -->
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div
                class="h-0.5 w-full bg-white"
                style="height: 0.125rem;"
              ></div>
            </div>
            <div
              class="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-green-400 text-green-800 bg-white"
            >
              {step_count + 1}
              <span class="sr-only">Step {step_count + 1}</span>
            </div>
          {:else}
            <!-- Upcoming Step -->
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div
                class="h-0.5 w-full bg-gray-400"
                style="height: 0.125rem;"
              ></div>
            </div>
            <div
              class="group relative flex h-8 w-8 items-center justify-center rounded-full text-gray-400 border-2 border-gray-400 bg-lwp-purple"
            >
              {step_count + 1}
              <span class="sr-only">Step {step_count + 1}</span>
            </div>
          {/if}
        </li>
      {/each}
    </ol>
  </nav>
</div>
